import { forwardRef } from "react";
import InternshipCard from "../components/InternshipCard";

const Internships = forwardRef((props, ref) => {
    const data = [
        {
            heading: "Web Dev Internship",
            content: "Overview, HTML5 & CSS3, Javascript, Responsive Website,Web Applications"
        },
        {
            heading: "Machine Learning Internship",
            content: "Overview, Data Analysis, Supervised Learning, Unsupervised Learning, Deep Learning"
        },
        {
            heading: "Data Science Internship",
            content: "Overview, DA, Data Pre- processing, Data Visualization, BI Tools"
        },
        {
            heading: "Android Dev Internship",
            content: "Overview, Kotlin, Simple Apps, Advanced Apps, Cloud Apps"
        }
    ]
    return (
        <section ref={ref}>
            <h2 className="missonHeading">Internships</h2>
            <div className="internship-card-wrapper">
                {data.map(item => {
                    return (
                        <InternshipCard heading={item.heading} content={item.content} />
                    )
                })}
            </div>
        </section>
    )

});

export default Internships